import React from 'react';
import { BiErrorCircle } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import BodyStep from '../../components/BodyStep';
import { Content } from '../../components/BodyStep/styles';

import { Container } from './styles';

const NotFound: React.FC = () => {
  return (
    <BodyStep>
      <Content>
        <Container>
          <h1>
            <BiErrorCircle />
            Página não encontrada
          </h1>
          <h4>
            Clique nesse <Link to="/">link</Link> para ter acesso a uma página
            existente
          </h4>
        </Container>
      </Content>
    </BodyStep>
  );
};

export default NotFound;
